import { DefaultFetchService } from "app/services/fetchService";
import queryString from "query-string";

interface IParams {
    country: string;
    from: string;
    to: string;
    includeSubDomains: boolean;
    isWindow: boolean;
    timeGranularity: string;
    webSource: string;
    keys: string;
}

interface IAudienceOverlapApiService {
    getDomainsAudienceOverlap: (params: IParams) => Promise<any>;
    getDomainsAudienceLoyalty: (params: IParams) => Promise<any>;
}
export default class AudienceOverlapApiService implements IAudienceOverlapApiService {
    protected fetchService;

    constructor() {
        this.fetchService = DefaultFetchService.getInstance();
    }

    private getData(params: any, endpoint): Promise<any> {
        const apiParams: any = {
            includeSubDomains: !params.isWWW,
            keys: params.keys,
            from: params.from,
            to: params.to,
            country: params.country,
            webSource: params.webSource,
            isWindow: params.isWindow,
            timeGranularity: "Monthly",
        };
        return this.fetchService.get(endpoint, apiParams);
    }

    public getDomainsAudienceOverlap(params: any): Promise<any> {
        return this.getData(params, "widgetApi/WebAudienceOverlap/AudienceOverlap/Data");
    }
    public getDomainsAudienceLoyalty(params: any): Promise<any> {
        return this.getData(params, "api/audienceLoyalty/Domains/Data");
    }

    public getDomainsAudienceOverlapExcelUrl(params: any): string {
        const apiParams: any = {
            includeSubDomains: !params.isWWW,
            keys: params.keys,
            from: params.from,
            to: params.to,
            country: params.country,
            webSource: params.webSource,
            isWindow: params.isWindow,
            imeGranularity: "Monthly",
        };
        const queryStringParams = queryString.stringify(apiParams);
        return `widgetApi/WebAudienceOverlap/AudienceOverlap/Excel?${queryStringParams}`;
    }
}
